export function applyMenuFilter(term: string): void {
  const normalized = term.trim().toLowerCase()
  const items = document.querySelectorAll<HTMLElement>(
    '#kt_app_sidebar .menu-item'
  )
  items.forEach((item) => {
    const text = (item.textContent || '').toLowerCase()
    item.style.display = !normalized || text.includes(normalized) ? '' : 'none'
  })
}

export function clearMenuFilter(): void {
  applyMenuFilter('')
}

export function focusMenuFilterInput(): void {
  document
    .querySelector<HTMLInputElement>('[data-admin-menu-filter="true"]')
    ?.focus()
}
